jQuery(function(){
  if(!jQuery('body').hasClass('vpc-configurator')) {
    return
  }
  /*************
  Variables
  */
  const lang = jQuery('html').attr('lang')

  /*************
  Function Calls
  */
  jQuery(window).on('load', function() {
    showInputPreview()
    changeTextColor()
  })

  function showInputPreview() {
    setInterval(function() {
      jQuery('#text-line-one-preview, #text-line-two-preview').remove()
      
      let valFirst
      let valSecond

      switch (lang) {
        case 'de-DE':
          valFirst = jQuery('#erste-zeile-field').val()
          valSecond = jQuery('#zweite-zeile-field').val()
          break
        case 'en-US':
          valFirst = jQuery('#first-line-field').val()
          valSecond = jQuery('#second-line-field').val()
          break
        case 'fr-FR':
          valFirst = jQuery('#premiere-ligne-field').val()
          valSecond = jQuery('#deuxieme-ligne-field').val()
          break
        case 'es-ES':
          valFirst = jQuery('#primera-linea-field').val()
          valSecond = jQuery('#segunda-linea-field').val()
          break
        case 'it-IT':
          valFirst = jQuery('#prima-linea-field').val()
          valSecond = jQuery('#seconda-linea-field').val()
          break
        default:
          valFirst = ''
          valSecond = ''
          break
      }

      jQuery('#vpc-preview-wrap .vpc-global-preview').append('<div id="text-line-one-preview">' + valFirst +'</div><div id="text-line-two-preview">' + valSecond + '</div>')
    }, 1000)
  }

  function changeTextColor() {
    const vpcPreview = jQuery('.vpc-global-preview')

    jQuery('.vpc-options .vpc-single-option-wrap input').on('click', function() {
      let $this = jQuery(this)
      let value = $this.val()

      switch(value) {
        // Deutsch
        case "Blau":
        case "Navy":
        case "Bordeaux Rot":
        case "Dunkelgrau":
        case "Grün":
        case "Rot":
        case "Schwarz":
        case "Violett":
        case "Blue":
        case "Bordeaux Red":
        case "Dark grey":
        case "Green":
        case "Red":
        case "Black":
        case "Purple":
        case "Bleu":
        case "Marine":
        case "Bordeaux rouge":
        case "Gris foncé":
        case "Vert":
        case "Rouge":
        case "Noir":
        case "Violet":
        case "Azul":
        case "Marina":
        case "Rojo Burdeos":
        case "Gris oscuro":
        case "Verde":
        case "Rojo":
        case "Negro":
        case "Púrpura":
        case "Blu":
        case "Marina Militare":
        case "Rosso Bordeaux":
        case "Grigio scuro":
        case "Rosso":
        case "Nero":
        case "Viola":
          vpcPreview.removeClass('text-color-white')
          vpcPreview.removeClass('text-color-black')
          vpcPreview.addClass('text-color-white')
          break
        // Deutsch
        case "Weiß":
        case "Gelb":
        case "Hellblau":
        case "Hellgrau":
        case "Neon Gelb":
        case "Neon Grün":
        case "White":
        case "Yellow":
        case "Light blue":
        case "Light Grey":
        case "Neon Yellow":
        case "Neon Green":
        case "Neon Pink":
        case "Orange":
        case "Blanc":
        case "Jaune":
        case "Bleu clair":
        case "Gris clair":
        case "Néon rose":
        case "vert néon":
        case "Jaune néon":
        case "Blanco":
        case "Amarillo":
        case "Azul claro":
        case "Gris claro":
        case "Amarillo Neón":
        case "Verde Neón":
        case "Rosa de Neón":
        case "Naranja":
        case "Bianco":
        case "Giallo":
        case "Azzurro":
        case "Grigio chiaro":
        case "Giallo Neon":
        case "Verde Neon":
        case "Rosa Neon":
        case "Arancione":
          vpcPreview.removeClass('text-color-white')
          vpcPreview.removeClass('text-color-black')
          vpcPreview.addClass('text-color-black')
          break
      }
    })
  }
})
